import styled, { css } from 'styled-components/macro';

export const DropdownOption = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: ${({ type }) =>
        type === 'team' ? 'flex-start' : 'space-between'};
    margin-bottom: 8px;
    min-height: 48px;
    padding: 0 8px;
    position: relative;
    cursor: pointer;
    border-radius: ${({ theme }) => theme.border.radiusSmall};

    &:hover {
        background-color: ${({ theme }) => theme.color.bgPrimaryLight};
    }
`;
export const WrapperInfoOption = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
`;
export const DropdownAvatar = styled.div`
    display: flex;
    align-items: center;

    img,
    svg {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        margin-right: 8px;
        object-fit: cover;
    }
`;

export const DropdownOptionTexts = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: flex-start;

    span {
        overflow: hidden;
        max-width: 100%;
        text-overflow: ellipsis;
    }

    small {
        overflow: hidden;
        max-width: 100%;
        text-overflow: ellipsis;
        color: ${({ theme }) => theme.color.textLight};
    }
`;

export const EmptyAvatar = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0px;
    margin-right: 8px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    text-align: center;
    vertical-align: middle;
    line-height: 32px;
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.color.primary};
    background-color: ${({ theme }) => theme.color.bgPrimaryLight};

    ${({ color }) =>
        color &&
        css`
            color: ${color};
        `}

    ${({ backgroundColor }) =>
        backgroundColor &&
        css`
            background-color: ${backgroundColor};
        `}
`;
